<div class="row">
  <div class="col-md-12">
    <div class="card input-style">
      <div class="card-header background-white pad1">
        <div class="row">
          <div class="col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Book Appointment</label>
          </div>
          <div class="offset-md-6 col-md-3">
            <label class="title font-size-20px margin-top-0px margin-bottom-0px">Step 1 of 4</label>
          </div>
        </div>
      </div>
      <div class="card-body background-white">
        <div class="col-md-12 col-xs-12 col-xl-12 padding-right-0px">
          <div class="row">
            <div class="offset-md-2 col-md-5 col-xl-5 margin-right-0px">
              <div class="row">
                <label class="font-size-18px margin-left-14px margin-top-10">Please Select type of Patient</label>
              </div>
            </div>
          </div>


          <div class="row">
            <div class="offset-md-2 col-md-9 col-xl-9 margin-right-0px margin-top-20px">

              <label class="radio-inline margin-right-30px">

                Registered patient <a class="nav-link-hand margin-left-5px" > <input type="radio"> </a>
              </label>
              <label class="radio-inline margin-left-35px ">
                Guest/New patient <a class="nav-link-hand margin-left-5px" > <input type="radio"> </a>
              </label>

            </div>

          </div>

        </div>

      </div>
    </div>
  </div>
</div>






